import React from 'react'
import { faMicrochip, faDoorOpen } from '@fortawesome/pro-regular-svg-icons'

class Marker extends React.Component {
  componentWillMount() {
    const { setMarker, setFillMarker, position, map, color, locked, isController } = this.props
    const icon = isController ? faMicrochip.icon : faDoorOpen.icon

    this.marker = new google.maps.Marker({
      position: position,
      icon: {
        path: icon[4],
        scale: EXPORT ? 0.045 : 0.035,
        fillColor: '#ffffff',
        fillOpacity: 1,
        anchor: new google.maps.Point(icon[0] / 2, icon[1] / 2)
      },
      draggable: false,
      clickable: false,
      zIndex: 1,
      map
    })

    this.fillMarker = new google.maps.Marker({
      position: position,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        strokeWeight: 2,
        strokeColor: color,
        strokeOpacity: 0.75,
        scale: EXPORT ? 20 : 15,
        fillColor: color,
        fillOpacity: 0.75
      },
      draggable: !locked,
      raiseOnDrag: false,
      zIndex: 0,
      map
    })

    setMarker(this.marker)
    setFillMarker(this.fillMarker)
  }

  componentDidMount() {
    const { id, isController, updateEntityAction, messageAction } = this.props
    this.fillMarker.addListener('dragend', e => updateEntityAction(isController ? 'doorControllers' : 'doors', id, { location: e.latLng.toJSON() }))
    this.fillMarker.addListener('position_changed', _ => this.marker.setPosition(this.fillMarker.getPosition()))
    this.fillMarker.addListener('mousedown', _ => this.props.locked && messageAction('generalError', `This ${isController ? 'Door Controller' : 'Door'} is locked. Right click to unlock.`))
  }

  componentWillReceiveProps({ position, color, locked }) {
    if (this.props.position.lat() !== position.lat() ||
        this.props.position.lng() !== position.lng()) {
      this.marker.setPosition(position)
      this.fillMarker.setPosition(position)
    }

    if (locked !== this.props.locked && !EXPORT) this.fillMarker.setOptions({ draggable: !locked })
    if (color !== this.props.color) {
      this.fillMarker.set('icon', { ...this.fillMarker.getIcon(), strokeColor: color, fillColor: color })
    }
  }

  shouldComponentUpdate() {
    return false
  }

  render() {
    return null
  }
}

export default Marker



// WEBPACK FOOTER //
// ./src/components/DoorEntity/marker.js